import { useEffect } from "react";
import { useBreadcrumb } from "../shell/ContextHeader";

// Designed empty states for nav destinations whose features arrive in later
// slices of Release 1 (Actions, Instrument library) or are deliberately not
// self-service in Release 1 (Administration). §11 requires every reachable
// state to be designed; "coming soon" with no explanation is not a design.

const COPY: Record<string, { title: string; body: string }> = {
  actions: {
    title: "Actions",
    body:
      "The corrective-action register. Findings from finalised assessment " +
      "runs convert into owned actions here, with their lineage retained. " +
      "It fills once the first run is finalised.",
  },
  instruments: {
    title: "Instrument library",
    body:
      "The published instruments this organisation can run. Instrument " +
      "versions are immutable once published - a run is locked to the " +
      "version it was created with.",
  },
  admin: {
    title: "Administration",
    body:
      "Organisation membership and roles are provisioned by LINNFOSS in " +
      "Release 1 - there is no self-service tenant administration yet. " +
      "Contact LINNFOSS to add or change members. The member roster is " +
      "visible to every member of the organisation.",
  },
};

export function Placeholder({ id }: { id: keyof typeof COPY }) {
  const { setTrail } = useBreadcrumb();
  const copy = COPY[id]!;
  useEffect(() => setTrail([{ label: copy.title }]), [setTrail, copy.title]);

  return (
    <>
      <h1>{copy.title}</h1>
      <div className="card empty-state">
        <p style={{ maxWidth: 520, margin: "0 auto" }}>{copy.body}</p>
      </div>
    </>
  );
}
